import Vue from "vue";
import Vuex from "vuex";
import user from './modules/user';
import staff from './modules/staff';
import org from './modules/organization';
import agency from './modules/agency';
import agencystaff from './modules/agencystaff';
import jsonData from './modules/text';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: true,
        language: "",
    },
    mutations: {
        setLoading(state, bool){
            state.loading = bool
        },
        setLanguage(state, lang){
            state.language = lang
        },
    },
    modules: {
        user: user,
        staff: staff,
        org: org,
        jsonData: jsonData,
        agency: agency,
        agencystaff: agencystaff
    }
})
